import {Heart, Lock, Receipt, ShieldCheck} from 'lucide-react';
import {VelaScene, type VelaRule} from '../engine/types';

export const checkoutRules: VelaRule[] = [
  {
    id: 'checkout/why-this-amount',
    section: 'goodToKnow',
    scenes: [VelaScene.Checkout],
    priority: 30,
    evaluate: (_, t) => ({
      id: 'why-this-amount',
      icon: <Receipt />,
      title: t('card.why_this_amount.title'),
      description: t('card.why_this_amount.body'),
    }),
  },
  {
    id: 'checkout/when-does-the-hold-release',
    section: 'goodToKnow',
    scenes: [VelaScene.Checkout],
    priority: 20,
    evaluate: (_, t) => ({
      id: 'when-does-the-hold-release',
      icon: <ShieldCheck />,
      title: t('card.when_does_the_hold_release.title'),
      description: t('card.when_does_the_hold_release.body'),
    }),
  },
  {
    id: 'checkout/it-shapes-the-next-stay',
    section: 'goodToKnow',
    scenes: [VelaScene.CheckoutRate],
    priority: 30,
    evaluate: (_, t) => ({
      id: 'it-shapes-the-next-stay',
      icon: <Heart />,
      title: t('card.it_shapes_the_next_stay.title'),
      description: t('card.it_shapes_the_next_stay.body'),
    }),
  },
  {
    id: 'checkout/private-by-default',
    section: 'goodToKnow',
    scenes: [VelaScene.CheckoutRate],
    priority: 20,
    evaluate: (_, t) => ({
      id: 'private-by-default',
      icon: <Lock />,
      title: t('card.private_by_default.title'),
      description: t('card.private_by_default.body'),
    }),
  },
];
